module.exports = __webpack_public_path__ + "static/img/card-02.d03a6c4.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/card-02.jpeg
// module id = eDlv
// module chunks = 14